export default __webpack_public_path__ + "static/media/mail.6aaf9606.svg";